export enum ServiceRequestVisibilityEnum {
  PUBLIC = 'public',
  PRIVATE = 'private',
}
